import { CDC_START_SCREEN_MAP } from '@/setup/globals';
import i18n from '@/setup/i18n.js';
import useNotificationStore from '@/stores/notification';
import { showCDCScreenSet, showErrorNotification } from '@/plugins/cdc/shared.js';

export const SCREEN_SET_NAME = 'General-RegistrationLogin';

const START_SCREEN_MAP = {
  [CDC_START_SCREEN_MAP.basic]: null,
  [CDC_START_SCREEN_MAP.register]: null,
  [CDC_START_SCREEN_MAP.upgradeToBasic]: null,
  [CDC_START_SCREEN_MAP.upgradeToProfessional]: 'onUpgradingProcessStarted',
  [CDC_START_SCREEN_MAP.upgradeToProfessionalAndRegisterDevice]: 'onUpgradingProcessStarted',
  [CDC_START_SCREEN_MAP.registerDevice]: null,
};

/**
 * Shows the desired registration form to the user, if available.
 *
 * @param {String} startScreen - The desired startScreen of CDC.
 *
 * @returns {Promise}
 */
export function showRegistration(startScreen) {
  return new Promise((resolve, reject) => {
    const callbackKey = START_SCREEN_MAP[startScreen];

    if (callbackKey === undefined) {
      useNotificationStore().showUnknownError();

      reject(new Error(`Unknown 'startScreen' for 'showRegistration': '${startScreen}'`));
    } else if (window.gigya?.accounts) {
      if (callbackKey) {
        window.gigya.thisScript.globalConf[callbackKey] = (response) => {
          resolve(response);
        };
      }

      showCDCScreenSet({
        screenSet: SCREEN_SET_NAME,
        startScreen,
      });
    } else {
      showErrorNotification(i18n.global.t('globalMessages.loginUnavailable'));

      reject();
    }
  });
}

/**
 * Show the upgrade to professional registration form. Optional with device registration.
 * If there is no logged-in user the register form will always be shown https://tracker.ivoclarvivadent.com/browse/CA-4131.
 *
 * @param {Boolean} [registerDevice] - Defines if the device registration should be shown as well.
 * @param {Boolean} [isUserLoggedIn] - Defines if the user is logged in.
 *
 * @returns {Promise}
 */
export function showUpgradeToProfessional(registerDevice = false, isUserLoggedIn = false) {
  let startScreen = CDC_START_SCREEN_MAP.registerDevice;

  if (isUserLoggedIn) {
    startScreen = registerDevice
      ? CDC_START_SCREEN_MAP.upgradeToProfessionalAndRegisterDevice
      : CDC_START_SCREEN_MAP.upgradeToProfessional;
  }

  return showRegistration(startScreen);
}

export const cdcRegistrationPlugin = {
  showRegistration,
  showUpgradeToProfessional,
};
